import { BASE_URL_LEGACY } from "./";

export const alertsService = {
  getDetail,
  setFeedback,
  setCorrect,
};

function getDetail(dependant_user_id, timestamp) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  };

  return fetch(
    `${BASE_URL_LEGACY}/assisted_living/alerts/?dependant_user_id=${dependant_user_id}&timestamp=${timestamp}`,
    requestOptions
  )
    .then((response) => {
      if (!response.ok) {
        return Promise.reject(response.statusText);
      }

      return response.json();
    })
    .then((detail) => {
      return detail;
    });
}

function setCorrect(user, correct, id, timestamp) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "X-CSRFToken": JSON.parse(localStorage.getItem("CSRF")),
    },
    body: `dependant_user_id=${user.dependant_user_id}&id=${id}&correct=${correct}&assessment_timestamp=${timestamp}`,
    credentials: "include",
  };

  return fetch(`${BASE_URL_LEGACY}/assisted_living/alerts/`, requestOptions)
    .then((response) => {
      if (!response.ok) {
        return Promise.reject(response.statusText);
      }

      return response.json();
    })
    .then((detail) => {
      return detail;
    });
}

function setFeedback(user, feedback, id, timestamp) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "X-CSRFToken": JSON.parse(localStorage.getItem("CSRF")),
    },
    body: `dependant_user_id=${user.dependant_user_id}&id=${id}&feedback=${feedback}&assessment_timestamp=${timestamp}`,
    credentials: "include",
  };

  return fetch(`${BASE_URL_LEGACY}/assisted_living/alerts/`, requestOptions)
    .then((response) => {
      if (!response.ok) {
        return Promise.reject(response.statusText);
      }

      return response.json();
    })
    .then((detail) => {
      return detail;
    });
}

// function handleResponse(response) {
//   if (!response.ok) {
//     return Promise.reject(response.statusText);
//   }
//
//   return response.json();
// }
